import React from 'react';

const { version } = require('../../../package.json');

const Footer = () => {
    return (
        <footer className="footerbox text-center">
            <ul className=" d-sm-flex justify-content-center">
                <li>總公司：台北市松山區東興路8號</li>
                <li>
                    <a href="tel:+886-2-81724668">電話：(02)8172-4668</a>
                </li>
                <li>
                    <a href="mailto:info-center@uni-psg.com">
                        服務信箱: info-center@uni-psg.com
                    </a>
                </li>
            </ul>
            <p className="text-center">
                © 2023 President Securities Corporation All Rights Reserved
            </p>
            <p className="text-center">version: {version}</p>
        </footer>
    );
};

export default Footer;
